<div class="wrapper">
    <h5 mat-dialog-title>Are you sure?</h5>
    <mat-dialog-content>
        Are you sure you wish to {{ action && name ? action + ' ' + name + '?' : 'make this change?' }}
    </mat-dialog-content>
    <mat-dialog-actions>
        <button mat-button mat-dialog-close>Cancel</button>
        <button mat-button (click)="confirm()">{{ action ? (action | titlecase) : 'Confirm' }}</button>
    </mat-dialog-actions>
</div>